import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatCalendar, MatCalendarHeader } from '@angular/material/datepicker';
import { DateAdapter } from '@angular/material/core';
import { MatButton } from '@angular/material/button';
import { ReactiveFormsModule } from '@angular/forms';
import { FormRangeDatepickerComponent } from './form-range-datepicker.component';
import { TranslocoDirective } from '@jsverse/transloco';
import { uiKitScope } from '../../constants/ui-constant';
import { provideUiKitScope } from '../../providers';

@Component({
  selector: 'ui-range-datepicker-header',
  standalone: true,
  imports: [
    MatCalendarHeader,
    MatButton,
    ReactiveFormsModule,
    TranslocoDirective,
  ],
  template: `
    <ng-container *transloco="let t; prefix: 'uiKit'">
      <mat-calendar-header>
        <button mat-button (click)="setToday()" class="mr-5">
          {{ t('placeholders.today') }}
        </button>
      </mat-calendar-header>
    </ng-container>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [provideUiKitScope()],
})
export class FormRangeDatepickerHeader<D> {
  private calendar = inject<MatCalendar<D>>(MatCalendar);
  private dateAdapter = inject<DateAdapter<D>>(DateAdapter);
  private parentComponent = inject(FormRangeDatepickerComponent);

  setToday() {
    const today = this.dateAdapter.today();
    this.calendar.activeDate = today;

    const currentRange = this.parentComponent.rangeDates();

    const todayString = this.parentComponent.toUTCDateString(today as Date);

    const dateStart = this.parentComponent.toUTCDateString(
      currentRange.dateStart as Date,
    );

    const rangeDates = {
      dateStart: dateStart || todayString,
      dateEnd: todayString,
    };

    this.parentComponent.rangeDates.set(rangeDates);
    this.parentComponent.dateChange.emit(rangeDates);

    this.parentComponent.pickerMat().close();
  }

  protected readonly uiKitScope = uiKitScope;
}
